/**
 * Static metadata for the task board UI — Kanban column definitions and the
 * option lists that populate the filter sheet's dropdowns.
 *
 * The IN_PROGRESS column intentionally groups PROBLEM tasks alongside true
 * in-progress tasks so users see blocked work in the same visual lane.
 */
import { TaskStatus, TaskType } from "@/types";
import type { SortBy } from "@/stores/useTaskFilterStore";

export type KanbanColumnDef = {
  status: TaskStatus;
  statuses?: TaskStatus[];
  label: string;
  color: string;
};

export const KANBAN_COLUMNS: KanbanColumnDef[] = [
  { status: TaskStatus.PENDING, label: "Ei aloitettu", color: "bg-slate-500" },
  {
    status: TaskStatus.IN_PROGRESS,
    statuses: [TaskStatus.IN_PROGRESS, TaskStatus.PROBLEM],
    label: "Kesken",
    color: "bg-yellow-500",
  },
  { status: TaskStatus.COMPLETED, label: "Valmis", color: "bg-green-500" },
];

export const SORT_OPTIONS: { value: SortBy; label: string }[] = [
  { value: "deadline", label: "Määräaika" },
  { value: "taskName", label: "Tehtävän nimi" },
  { value: "ppCode", label: "Hankintapaketin koodi" },
];

export const TASK_TYPE_OPTIONS: { value: string; label: string }[] = [
  { value: TaskType.TEMPLATE_MAIN_TASK, label: "Pohjasta luotu päätehtävä" },
  { value: TaskType.INTERNAL_MAIN_TASK, label: "Käyttäjän luoma päätehtävä" },
  { value: TaskType.INSPECTION_MAIN_TASK, label: "Tarkastustehtävä" },
  { value: TaskType.DOCUMENT_MAIN_TASK, label: "Dokumenttitehtävä" },
];
